import React from "react";
import { logger } from "../utils/logger";
import Button from "@mui/material/Button";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render shows the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging
    logger.error("Uncaught error in component tree:", error, errorInfo);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full bg-white shadow-md rounded-lg p-6 text-center">
            <h1 className="text-xl font-semibold text-gray-800 mb-2">
              Something went wrong.
            </h1>
            <p className="text-gray-600 text-sm mb-4">
              An unexpected error occurred while loading the application.
            </p>
            <Button
              variant="contained"
              onClick={this.handleRefresh}
              sx={{
                backgroundColor: '#2563EB',
                textTransform: 'none',
                fontSize: '0.875rem',
                fontWeight: 500,
                '&:hover': { backgroundColor: '#1D4ED8' },
              }}
            >
              Refresh Page
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
